export interface AcquisitionAttribution {
  source?: string;
  medium?: string;
  campaign?: string;
  content?: string;
}

const KNOWN_REFERRALS: Record<string, Required<AcquisitionAttribution>> = {
  producthunt: {
    source: "producthunt",
    medium: "directory",
    campaign: "moneymap_producthunt_2026_09",
    content: "launch"
  },
  "spotstartups.com": {
    source: "spotstartups",
    medium: "directory",
    campaign: "moneymap_directory_2026_09",
    content: "listing"
  },
  "10015.io": {
    source: "10015",
    medium: "directory",
    campaign: "moneymap_directory_2026_09",
    content: "listing"
  },
  desifounder: {
    source: "desifounder",
    medium: "directory",
    campaign: "moneymap_spotlight_2026_09",
    content: "listing"
  },
  "desifounder-community": {
    source: "desifounder",
    medium: "community",
    campaign: "moneymap_founder_feedback_2026_09",
    content: "risk_ordering"
  },
  "reddit-sideproject": {
    source: "reddit",
    medium: "community",
    campaign: "moneymap_sideproject_rebuild_2026_09",
    content: "clarity_conversion_rebuild"
  }
};

/**
 * Product directories often append their own `ref` value instead of preserving
 * UTM parameters. Normalize only partners we know so arbitrary referral values
 * do not become acquisition dimensions. Explicit UTM values always win.
 */
export function parseAcquisitionAttribution(search: string): AcquisitionAttribution | undefined {
  const params = new URLSearchParams(search);
  const explicitSource = params.get("utm_source")?.trim();
  const ref = params.get("ref")?.trim().toLowerCase();
  const referral = explicitSource ? undefined : (ref ? KNOWN_REFERRALS[ref] : undefined);
  const source = explicitSource || referral?.source;
  const medium = params.get("utm_medium")?.trim() || referral?.medium;
  const campaign = params.get("utm_campaign")?.trim() || referral?.campaign;
  const content = params.get("utm_content")?.trim() || referral?.content;
  const entries: AcquisitionAttribution = {
    ...(source ? { source } : {}),
    ...(medium ? { medium } : {}),
    ...(campaign ? { campaign } : {}),
    ...(content ? { content } : {})
  };
  return Object.values(entries).some(Boolean) ? entries : undefined;
}
